import { Injectable } from "@angular/core";
import { INDRAURLService } from "@ibe.services/url.indra.service";
import { Router, ActivatedRoute } from "@angular/router";
import { INDRAStorageService } from "@ibe.services/storage.indra.service";
import { INDRAApiService } from "@ibe.services/api.indra.service";
import { INDRAUserData } from "@ibe.models/user.indra.model.lib";

import { LoginModalService } from "@ibe.services/login-modal.service";
import { HttpClient } from "@angular/common/http";
import { BookingFlowDeeplink } from "@ibe.models/booking-flow-deeplink.indra.model.lib";

import * as moment from 'moment';
import * as fromStore from '../store';
import { Store } from '@ngrx/store';
import * as UserActions from '@ibe/store/actions/user.actions';

import {
	URL_DEEPLINK_LOGIN,
	MOCK_STATUS,
	MOCK_LOGIN,
	DEFAULT_MARKET,
	DEFAULT_LANGUAGE,
	TRIP_TYPE_MULTICITY,
	TRIP_TYPE_ONE_WAY,
	TRIP_TYPE_ROUND_TRIP,
	DEEPLINK_FLIGHT_TYPE_SINGLE,
	DEEPLINK_FLIGHT_TYPE_RETURN,
	DEEPLINK_DATES_PAGE,
	DEEPLINK_FLIGHTS_PAGE,
	URL_DEEPLINK_FLOW,
	MOCK_URL_DEEPLINK_FLOW,
	DEEPLINK_MAGIC_WORD,
	DEEPLINK_FLIGHT_TYPE_MULTICITY,
	DEEPLINK_FLIGHTS_PAGE_STOPOVER,
	DEEPLINK_PARAM_OUTBOUND,
	URL_LOGIN,
    DEEPLINK_STOPOVER_ROUTE_EXCEPTION
} from '@ibe.config';
import { INDRADeeplinkFlowRes } from "@ibe.models/deeplink-flow.indra.model.lib";
import { INDRALanguageMarketService } from "./language-market-indra.service";
import { Md5 } from 'ts-md5/dist/md5';
import { Observable } from 'rxjs';
import { INDRADateService } from "./date.indra.service";


@Injectable({
	providedIn: 'root'
})
export class INDRADeepLinkService {

	milesGoDiscount: boolean = true;
	headerFooterHidden: boolean = false;

	constructor(
		private urlService: INDRAURLService,
		private router: Router,
		private storage: INDRAStorageService,
		private api: INDRAApiService,
		private loginModalService: LoginModalService,
		private http: HttpClient,
		private activatedRoute: ActivatedRoute,
		private languageMarketSService: INDRALanguageMarketService,
		private store: Store<fromStore.State>,
		private dateService: INDRADateService,
	) { }

	INDRA_getDeepLinkInformation(url: string) {
		let deeplinkInfo = {
			pnr: null,
			ticketnumber: null,
			lastname: null,
			source: null,
			market: null,
			language: null,
			uh: null,
			tapid: null,
			email: null
		};

		if ((url.indexOf('pnr') !== -1 ||
			url.indexOf('ticketnumber') !== -1) &&
			url.indexOf('lastname') != -1 &&
			url.indexOf('source') !== -1 &&
			url.indexOf('market') !== -1 &&
			url.indexOf('language') !== -1) {
			deeplinkInfo.pnr = this.urlService.INDRA_getUrlParams('pnr', url);
			deeplinkInfo.ticketnumber = this.urlService.INDRA_getUrlParams('ticketnumber', url);
			deeplinkInfo.lastname = this.urlService.INDRA_getUrlParams('lastname', url);
			deeplinkInfo.source = this.urlService.INDRA_getUrlParams('source', url);
			deeplinkInfo.market = this.urlService.INDRA_getUrlParams('market', url);
			if (deeplinkInfo.market.toUpperCase() === 'UK') {
				deeplinkInfo.market = 'GB';
			}
			deeplinkInfo.language = this.urlService.INDRA_getUrlParams('language', url);
			if (deeplinkInfo.language.includes('-')) {
				// parses the en-en, pt-PT, and es-ES to iso code..
				let parsedLanguage: string = deeplinkInfo.language;
				deeplinkInfo.language = parsedLanguage.substring(0, 2);
			}
			deeplinkInfo.uh = this.urlService.INDRA_getUrlParams('uh', url);
			deeplinkInfo.tapid = this.urlService.INDRA_getUrlParams('tapid', url);
			deeplinkInfo.email = this.urlService.INDRA_getUrlParams('email', url);
			sessionStorage.setItem('deeplinkRedirect', 'YES');
		}
		return deeplinkInfo;
	}

	INDRA_processDeepLinkInfo(deeplinkInfo) {
		let pnr: string;
		let lastName: string;
		if (deeplinkInfo.ticketnumber) {
			pnr = deeplinkInfo.ticketnumber;
		} else {
			pnr = deeplinkInfo.pnr;
		}
		lastName = deeplinkInfo.lastname;
		
		this.languageMarketSService.setMarket(deeplinkInfo.market.toUpperCase());

		const sessionLanguage = sessionStorage.getItem("language");
		if (!sessionLanguage) {
			this.languageMarketSService.setLanguage(deeplinkInfo.language.toLowerCase());
		}

		this.storage.set('deepLink', deeplinkInfo);
		if (deeplinkInfo.email && deeplinkInfo.tapid) {
			this.INDRA_deeplinkLogin(deeplinkInfo.email, deeplinkInfo.tapid).subscribe((response: INDRAUserData) => {
				if ((response.status === '200' || !response.errors || response.errors.length === 0) && response.data) {
					this.loginModalService.sendDataCustomer(response.data);
					const { userProfile, userPnrs, translate } = response.data;
					const userData = {
						...userProfile,
						userPnrs: userPnrs,
						translate: translate
					};
					this.storage.set('userData', userData);
				} else {
					sessionStorage.setItem('deeplinkLoginError', 'YES');
				}
				this.router.navigate(['/my-bookings/details/' + pnr + '/' + lastName]);
			}, (err) => {
				console.log(err);
				sessionStorage.setItem('deeplinkLoginError', 'YES');
				this.router.navigate(['/my-bookings/details/' + pnr + '/' + lastName]);
			});
		} else {
			this.router.navigate(['/my-bookings/details/' + pnr + '/' + lastName]);
		}
	}

	INDRA_deeplinkLogin(email: string, tapid: string) {
		const payload = {
			email: email,
			tapId: tapid
		};
		if (MOCK_STATUS.DEEPLINK_LOGIN) {
			return this.http.get<INDRAUserData>(MOCK_LOGIN);
		} else {
			return this.api.INDRA_post<INDRAUserData>(URL_DEEPLINK_LOGIN, payload);
		}
	}

	async INDRA_getBookingFlowDeeplinkParameter(urlQueryParams: any, deeplinkType: string) {
		const sessionLanguage = sessionStorage.getItem("language");
		let market = urlQueryParams['market'] !== undefined ? urlQueryParams['market'] : sessionStorage.getItem("market");
		// let language = urlQueryParams['language'] !== undefined ? urlQueryParams['language'].toLowerCase() : sessionStorage.getItem("language");
		let language = sessionLanguage ? sessionLanguage : urlQueryParams['language'];
		language = language ? language.toLowerCase() : '';
		const origin = urlQueryParams['origin'];
		const destination = urlQueryParams['destination'];
		const flightType = urlQueryParams['flightType'];
		const adt = urlQueryParams['adt'];
		const chd = urlQueryParams['chd'] ? urlQueryParams['chd'] : '0';
		const inf = urlQueryParams['inf'] ? urlQueryParams['inf'] : '0';
		const yth = urlQueryParams['yth'];
		let departureDate = urlQueryParams['depDate'];
		let returnDate = urlQueryParams['retDate'];
		const hash = urlQueryParams['uh'];
		const networkName = urlQueryParams['networkName'];
		let promocode = urlQueryParams['promocode'];
		let voucher = urlQueryParams['voucher'];
		let voucherEmail = urlQueryParams['voucherEmail'];
		let flexibleDates = urlQueryParams['flexibleDates'];
		let headerFooterHidden = urlQueryParams['headerfooterhidden'];
		if (headerFooterHidden) {
			this.headerFooterHidden = JSON.parse(headerFooterHidden);
		}

		const award = urlQueryParams['award'];
		const email = urlQueryParams['email'];
		const tapid = urlQueryParams['tapid'];
		const uid = urlQueryParams['uid'];
		const anetwork = urlQueryParams['anetwork'];
		const anetid = urlQueryParams['anetid'];
		const utm_source = urlQueryParams['utm_source'];
		const utm_campaign = urlQueryParams['utm_campaign'];
		const utm_content = urlQueryParams['utm_content'];
		const utm_medium = urlQueryParams['utm_medium'];
		const _a = urlQueryParams['_a'];
		const _b = urlQueryParams['_b'];
		const _c = urlQueryParams['_c'];
		let milesPromo = urlQueryParams['milesPromo'];

		const origin1 = urlQueryParams['origin1'];
		const origin2 = urlQueryParams['origin2'];
		const origin3 = urlQueryParams['origin3'];
		const origin4 = urlQueryParams['origin4'];
		const origin5 = urlQueryParams['origin5'];
		const destination1 = urlQueryParams['destination1'];
		const destination2 = urlQueryParams['destination2'];
		const destination3 = urlQueryParams['destination3'];
		const destination4 = urlQueryParams['destination4'];
		const destination5 = urlQueryParams['destination5'];
		let depDate1 = urlQueryParams['depDate1'];
		let depDate2 = urlQueryParams['depDate2'];
		let depDate3 = urlQueryParams['depDate3'];
		let depDate4 = urlQueryParams['depDate4'];
		let depDate5 = urlQueryParams['depDate5'];
		let otp = urlQueryParams['otp'];

		let originArray = [];
		let destinationArray = [];
		let depDateArray = [];

		// stopover parameters
		const stopoverCode = urlQueryParams['stopoverCode'];
		const country = urlQueryParams['country'];
		const days = urlQueryParams['days'];
		let country1 = urlQueryParams['country1'];
		let days1 = urlQueryParams['days1'];
		let stopoverCode1 = urlQueryParams['stopoverCode1'];
		const stopoverRoute = urlQueryParams['stopoverRoute'];
		const stopoverRoute1 = urlQueryParams['stopoverRoute1'];
		let isStopover = urlQueryParams['stopover'];

		// advanced-search filters
		const baggageIncluded = urlQueryParams['baggageIncluded'];
		const cabinOptions = urlQueryParams['cabinOptions'];
		const onlyRefundable = urlQueryParams['onlyRefundable'];
		const directFlights = urlQueryParams['directFlights'];
		const tapAirline = urlQueryParams['tapAirline'];

		//skyscanner
		const skyscannerRedirectId = urlQueryParams['skyscannerRedirectId'];

		// KAYAK metapartner
		const metapartner = urlQueryParams['metapartner'];

		// Forgerock
		const forgerocktoken = urlQueryParams['forgerocktoken'];
		
		const x_tap_source = urlQueryParams['x_tap_source'];
		const x_tap_username = urlQueryParams['x_tap_username'];
		const x_tap_correlationid = urlQueryParams['x_tap_correlationid'];

		let tripType;
		switch (flightType) {
			case DEEPLINK_FLIGHT_TYPE_SINGLE:
				tripType = TRIP_TYPE_ONE_WAY;
				break;
			case DEEPLINK_FLIGHT_TYPE_RETURN:
				tripType = TRIP_TYPE_ROUND_TRIP;
				break;
			case DEEPLINK_FLIGHT_TYPE_MULTICITY:
				tripType = TRIP_TYPE_MULTICITY;
				break;
			default:
				tripType = TRIP_TYPE_ONE_WAY;
				break;
		}

		if (departureDate) {
			departureDate = this.parseDate(departureDate);
		}
		if (returnDate) {
			returnDate = this.parseDate(returnDate);
		}

		if (deeplinkType === DEEPLINK_FLIGHT_TYPE_MULTICITY ||
			(deeplinkType === DEEPLINK_FLIGHTS_PAGE_STOPOVER && tripType === TRIP_TYPE_MULTICITY)) {

			if (depDate1) {
				depDate1 = this.parseDate(depDate1);
			}
			if (depDate2) {
				depDate2 = this.parseDate(depDate2);
			}
			if (depDate3) {
				depDate3 = this.parseDate(depDate3);
			}
			if (depDate4) {
				depDate4 = this.parseDate(depDate4);
			}
			if (depDate5) {
				depDate5 = this.parseDate(depDate5);
			}

			depDateArray.push(departureDate, depDate1, depDate2, depDate3, depDate4, depDate5);
			originArray.push(origin, origin1, origin2, origin3, origin4, origin5);
			destinationArray.push(destination, destination1, destination2, destination3, destination4, destination5);

			depDateArray = depDateArray.filter(date => date != undefined);
			originArray = originArray.filter(orig => orig != undefined);
			destinationArray = destinationArray.filter(dest => dest != undefined);
		}

		// validations for required values
		switch (deeplinkType) {
			case DEEPLINK_DATES_PAGE:
				if (!origin || origin.length === 0 || !destination || destination.length === 0) return null;
				break;
			case DEEPLINK_FLIGHTS_PAGE:
				if (!origin || origin.length === 0 || !destination || !departureDate || destination.length === 0 ||
					(tripType === TRIP_TYPE_ROUND_TRIP && (!returnDate || returnDate.length === 0)) ||
					(departureDate && !moment(departureDate, "DD.MM.YYYY", true).isValid()) ||
					(tripType === TRIP_TYPE_ROUND_TRIP && returnDate && !moment(returnDate, "DD.MM.YYYY", true).isValid())) {
					return null;
				}
				break;
			case DEEPLINK_FLIGHT_TYPE_MULTICITY:
				if (!origin || origin.length === 0 || !destination || destination.length === 0 ||
					originArray.length != depDateArray.length || originArray.length != destinationArray.length || depDateArray.length != destinationArray.length ||
					!depDateArray[1] || !originArray[1] || !destinationArray[1] ||
					(departureDate && !moment(departureDate, "DD.MM.YYYY", true).isValid())
					|| depDateArray.length < 1 || originArray.length < 1 || destinationArray.length < 1
				) {
					return null;
				}
				break;
			case DEEPLINK_FLIGHTS_PAGE_STOPOVER:
				if (!origin || origin.length === 0 || !destination || !departureDate || destination.length === 0 ||
					(tripType === TRIP_TYPE_ROUND_TRIP && (!returnDate || returnDate.length === 0)) ||
					(departureDate && !moment(departureDate, "DD.MM.YYYY", true).isValid()) ||
					(tripType === TRIP_TYPE_ROUND_TRIP && returnDate && !moment(returnDate, "DD.MM.YYYY", true).isValid())
					|| !stopoverCode || !country || !days) {
					return null;
				}

				if (tripType === TRIP_TYPE_MULTICITY && !origin1 && !destination1 && !depDate1) {
					return null;
				}
				break;
			default:
				break;
		}

		// check for correct hash
		// if (hash) {
		// 	if (flightType === DEEPLINK_FLIGHT_TYPE_SINGLE || flightType === DEEPLINK_FLIGHT_TYPE_RETURN) {
		// 		const paramHashString = DEEPLINK_MAGIC_WORD + '_' + origin + destination + (departureDate ? departureDate : '') + (returnDate ? returnDate : '') + adt + chd + inf;
		// 		const md5 = new Md5();
		// 		const generatedHash = md5.appendStr(paramHashString).end();
		// 		if (generatedHash !== hash) {
		// 			return null;
		// 		}
		// 	}
		// }

		if (networkName !== 'EMUNDO') {
			// miles&go promo
			if (award == 'true' && milesPromo == 'Y') {
				milesPromo = null;
			}
			if (milesPromo == 'Y' && inf != '0') {
				milesPromo = null;
			}
	
			// vouchers & promocodes
			if (milesPromo == 'Y' && (voucher || promocode)) {
				voucher = null;
				voucherEmail = null;
				promocode = null;
			}
			if (award == 'true' && voucher) {
				voucher = null;
				voucherEmail = null;
	
			}
		}

		// pre-processing of market and language
		if (!sessionLanguage) {
			if (language && language.includes('-')) {
				if (language.toLowerCase() != 'pt-br') {
					language = language.substring(0, 2);
				}
			} else {
				language = language && language !== 'null' && language.length > 0 ? language : DEFAULT_LANGUAGE;
			}
		}

		if (market && market.toUpperCase() === 'UK') {
			market = 'GB';
		} else if (market && market.toUpperCase() === 'RU') {
			market = 'PT';
		} else {
			market = market && market !== 'null' && market.length > 0 ? market.toUpperCase() : DEFAULT_MARKET;
		}

		const apiParam = {
			network: networkName,
			origin: origin,
			origin1: origin1,
			origin2: origin2,
			origin3: origin3,
			origin4: origin4,
			origin5: origin5,
			destination: destination,
			destination1: destination1,
			destination2: destination2,
			destination3: destination3,
			destination4: destination4,
			destination5: destination5,
			depDate: departureDate ? this.INDRA_formatDateParam(departureDate) : '',
			depDate1: depDate1 ? this.INDRA_formatDateParam(depDate1) : '',
			depDate2: depDate2 ? this.INDRA_formatDateParam(depDate2) : '',
			depDate3: depDate3 ? this.INDRA_formatDateParam(depDate3) : '',
			depDate4: depDate4 ? this.INDRA_formatDateParam(depDate4) : '',
			depDate5: depDate5 ? this.INDRA_formatDateParam(depDate5) : '',
			award: award,
			email: email,
			tapid: tapid,
			anetwork: anetwork,
			anetid: anetid,
			utmSource: utm_source,
			utmContent: utm_content,
			utmMedium: utm_medium,
			a: _a,
			b: _b,
			c: _c,
			voucher: voucher,
			voucherEmail: voucherEmail,
			milesPromo: milesPromo,
			retDate: returnDate ? this.INDRA_formatDateParam(returnDate) : '',
			adt: urlQueryParams['adt'],
			chd: urlQueryParams['chd'] ? urlQueryParams['chd'] : '0',
			inf: urlQueryParams['inf'] ? urlQueryParams['inf'] : '0',
			flightType: flightType,
			market: market,
			language: language,
			promocode: promocode ? promocode : '',
			hash: hash,
			skyscannerRedirectId: skyscannerRedirectId,
      		otp: otp,
			metapartner: metapartner,
			forgerocktoken: forgerocktoken,
			x_tap_source,
			x_tap_username,
			x_tap_correlationid,
		};

		if (apiParam.origin && apiParam.destination && apiParam.adt && apiParam.flightType) {
			try {
				const deeplinkAPiPromise = await this.INDRA_deeplinkFlow(apiParam).toPromise();
			} catch (err) {
				console.error('deeplink api error: ' + JSON.stringify(err));
			}
		}

		this.languageMarketSService.setMarket(market);

		if (language && !sessionLanguage) {
			this.languageMarketSService.setLanguage(language);
		}

		const deeplinkParameter: BookingFlowDeeplink = {
			market: market,
			language: (language && language.length > 0 ? language : DEFAULT_LANGUAGE),
			origin: origin,
			destination: destination,
			flightType: tripType,
			adultCount: adt ? parseInt(adt, 10) : 0,
			childCount: chd ? parseInt(chd, 10) : 0,
			infantCount: inf ? parseInt(inf, 10) : 0,
			youngAdultCount: yth ? parseInt(yth, 10) : 0,
			promocode: promocode,
			hash: hash,
			networkName: networkName,
			departureDate: departureDate,
			arrivalDate: returnDate,
			award: award === 'true' ? true : false,
			email: email,
			tapid: tapid,
			uid: uid,
			anetid: anetid,
			originArray: originArray,
			destinationArray: destinationArray,
			depDateArray: depDateArray,
			milesPromo: milesPromo,
			voucher: voucher,
			voucherEmail: voucherEmail,
			stopoverCode: stopoverCode,
			isStopover: isStopover ? (isStopover === 'true' ? true : false) : undefined,
			country: country,
			days: days ? parseInt(days, 10) : 0,
			days1: days1 ? parseInt(days1, 10) : 0,
			country1: country1,
			stopoverCode1: stopoverCode1,
			stopoverRoute: stopoverRoute,
			stopoverRoute1: stopoverRoute1,
			flexibleDates: flexibleDates,
			headerfooterhidden: headerFooterHidden,
			baggageIncluded: baggageIncluded,
			cabinOptions: cabinOptions,
			onlyRefundable: onlyRefundable,
			directFlights: directFlights,
			tapAirline: tapAirline,
			skyscannerRedirectId: skyscannerRedirectId,
      		otp: otp,
			metapartner: metapartner,
			forgerocktoken: forgerocktoken,
			x_tap_source,
			x_tap_username,
			x_tap_correlationid,
		};

		return deeplinkParameter;
	}

	INDRA_setMarketLanguageForTTTCompletionFlow(urlQueryParams: any) {
		const sessionLanguage = sessionStorage.getItem("language");
		let market = urlQueryParams['market'] !== undefined ? urlQueryParams['market'] : sessionStorage.getItem("market");
		// let language = urlQueryParams['language'] !== undefined ? urlQueryParams['language'].toLowerCase() : sessionStorage.getItem("language");
		let language = sessionLanguage ? sessionLanguage : urlQueryParams['language'];
		language = language ? language.toLowerCase() : '';
		
		// pre-processing of market and language
		if (!sessionLanguage) {
			if (language && language.length > 0) {
				if (language.includes('-')) {
					language = language.substring(0, 2);
				}
			} else {
				// language = DEFAULT_LANGUAGE;
				language = null;
			}
		}

		if (market && market.length > 0) {
			if (market.toUpperCase() === 'UK') {
				market = 'GB';
			}
			market = market.toUpperCase();
		} else {
			// market = DEFAULT_MARKET;
			market = null;
		}

		if (market) {
			this.store.dispatch(new UserActions.PutMarketAction(market));
			this.languageMarketSService.setMarket(market);
		}
		if (language && !sessionLanguage) {
			this.languageMarketSService.setLanguage(language);
		}

		return { market: market, language: language };
	}


	private parseDate(dateStr) {
		const dateComponents = dateStr.match(/(\d+)/g);
		return new Date(dateComponents[2], dateComponents[1] - 1, dateComponents[0]);
	}

	INDRA_deeplinkFlow(param) {
		if (MOCK_STATUS.DEEPLINK_FLOW) {
			return this.http.get<INDRADeeplinkFlowRes>(MOCK_URL_DEEPLINK_FLOW);
		} else {
			return this.api.INDRA_post<INDRADeeplinkFlowRes>(URL_DEEPLINK_FLOW, param);
		}
	}

	get milesGoPromo(): boolean {
		return this.milesGoDiscount;
	}

	set milesGoPromo(discount: boolean) {
		this.milesGoDiscount = discount;
	}

	public INDRA_login(uid: any, forgerocktokenStr = null): Observable<INDRAUserData> {
		let data = {};
		if (!forgerocktokenStr) {
			let flyTapInfo = this.INDRA_getFlyTapInformation(uid);
			data = {
				flyTapLogin: true,
				flyTapToken: flyTapInfo.flyTapToken,
				customerId: flyTapInfo.customerId,
				forgerocktoken :  forgerocktokenStr
			};
		} else {
			data = {
				forgerocktoken :  forgerocktokenStr
			};
		}

		if (MOCK_STATUS.LOGIN) {
			return this.api.INDRA_get<any>(MOCK_LOGIN);
		} else {
			return this.api.INDRA_post<INDRAUserData>(URL_LOGIN, data);
		}
	}

	INDRA_getFlyTapInformation(uidString: string) {
		const flyTapInfo = {
			flyTapLogin: true,
			customerId: null,
			flyTapToken: null
		};

		const uid = uidString;
		const uidParts = uid.split('.');
		const UIDLogin = JSON.parse(atob(uidParts[1]));
		flyTapInfo.customerId = UIDLogin.CustomerID;
		flyTapInfo.flyTapToken = uid;
		return flyTapInfo;
	}

	INDRA_formatDateParam(date: string) {
		return this.dateService.INDRA_formatDate(date, 'DDMMYYYY');
	}

	INDRA_setMarketLanguageForExternalDeeplink(urlQueryParams: any) {
		const sessionLanguage = sessionStorage.getItem("language");
		let market = urlQueryParams['market'] !== undefined ? urlQueryParams['market'] : sessionStorage.getItem("market");
		// let language = urlQueryParams['language'] !== undefined ? urlQueryParams['language'].toLowerCase() : sessionStorage.getItem("language");
		let language = sessionLanguage ? sessionLanguage : urlQueryParams['language'];
		language = language ? language.toLowerCase() : '';
		
		// pre-processing of market and language
		if (!sessionLanguage) {
			if (language && language.length > 0) {
				if (language.includes('-')) {
					language = language.substring(0, 2);
				}
			} else {
				// language = DEFAULT_LANGUAGE;
				language = null;
			}	
		}

		if (market && market.length > 0) {
			if (market.toUpperCase() === 'UK') {
				market = 'GB';
			}
			market = market.toUpperCase();
		} else {
			// market = DEFAULT_MARKET;
			market = null;
		}

		if (market) {
			this.store.dispatch(new UserActions.PutMarketAction(market));
			this.languageMarketSService.setMarket(market);
		}
		if (language && !sessionLanguage) {
			this.languageMarketSService.setLanguage(language);
		}

		return { market: market, language: language };
	}

	INDRA_isRouteValidStopover(route: string): boolean {
		return route && !DEEPLINK_STOPOVER_ROUTE_EXCEPTION.includes(route);
	}
}
